import Head from 'next/head'
import type { FC } from 'react'

import { Footer } from '@/components/elements/footer/Footer'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { SubNavigation } from '@/elements/global/SubNavigation'
import { Header } from '@/elements/header/Header'

import type { AcademyAuthor, AcademyAuthorArticles, AcademyCategories } from '../AcademyContentPage'
import { FeaturedArticles } from '../FeaturedArticles/FeaturedArticles'
import { AuthorCard } from './AuthorProfile'

type AuthorPageProps = {
  author: AcademyAuthor
  articles?: AcademyAuthorArticles
  categories: AcademyCategories
}

export const AuthorPage: FC<AuthorPageProps> = ({ author, articles, categories }) => {
  return (
    <>
      <SEOMetaTags metaData={{ title: author.name, description: author.briefBio }} />
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <Header />
      <SubNavigation title="Learn" categories={categories} />
      <main id="main-content">
        <article aria-label={author.name} className="article">
          <AuthorCard author={author} />
          <FeaturedArticles articles={articles ?? []} showViewMoreButton={true} />
        </article>
      </main>
      <Footer showPreFooter />
    </>
  )
}
